var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topBox"}),_c('div',{staticClass:"mark"},[_c('i',{staticClass:"iconfont icon-educesuan-icon"})]),_c('p',{staticClass:"warn"},[_vm._v("额度测算中")]),_c('div',{staticClass:"tip"},[_c('p',[_vm._v("您的融资申请已提交到资金方，审批结果需要")]),_c('p',[_vm._v("一定时间，请您耐心等待")])])])
}]

export { render, staticRenderFns }